import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: '160px',
      [theme.breakpoints.down(480)]: {
        display: 'flex',
        flexDirection: 'row',
        maxWidth: '380px',
        width: '100%',
        borderRadius: '13px',
        boxShadow: '0px 5px 20px #64646433'
      }
    },
    description: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: '6px',
      [theme.breakpoints.down(480)]: {
        marginLeft: '16px'
      }
    },
    imageCar: {
      maxWidth: '160px',
      width: '100%',
      height: '110px',
      borderRadius: '13px',
      [theme.breakpoints.down(480)]: {
        maxWidth: '140px',
      }
    },
    carName: {
      color: theme.palette.primary.main,
      fontSize: '16px',
      fontWeight: 'bold',
    },
    carKm: {
     color: '#646464',
     fontSize: '14px',
     [theme.breakpoints.down(480)]: {
       fontSize: '12px',
       margin: '6px 0',
      }
    }
  })
)

export default useStyles;